export default "__VITE_ASSET__7d341717__"